/**
 * @generated SignedSource<<4456e5f6661dc920c89b3b8e71a122dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AccountType = "CHAIN" | "INDIVIDUAL" | "%future added value";
export type Cleanliness = "BAD" | "GREAT" | "MEDIUM" | "%future added value";
export type ConnectionStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type CustomerSatisfaction = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type JobTypes = "INSTALLATION" | "INSTALLATION_FOLLOW_UP" | "SAMPLE_EVENT" | "SITE_VISIT" | "%future added value";
export type Priority = "HIGH" | "HIGHEST" | "LOW" | "MEDIUM" | "%future added value";
export type ServiceType = "ON_SITE" | "REMOTE" | "%future added value";
export type Status = "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "%future added value";
export type Statuses = "ARCHIVED" | "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "%future added value";
export type TicketType = "LAB" | "MARKETING_OTHER" | "PREVENTIVE_MAINTANANCE" | "REACTIVE_MAINTANANCE" | "%future added value";
export type TrafficRate = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type TypeOfContactPhoneNumber = "OFFICE" | "PERSONAL" | "%future added value";
export type CustomerHistory_getCustomerByIdQuery$variables = {
  id: string;
};
export type CustomerHistory_getCustomerByIdQuery$data = {
  readonly getCustomerById: {
    readonly accountType: AccountType | null;
    readonly createdAt: any | null;
    readonly createdBy: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly customerCompanyName: string | null;
    readonly customerContactEmail: string | null;
    readonly customerContactName: string | null;
    readonly customerContactNameRole: string | null;
    readonly customerContactPhoneNumber: string | null;
    readonly customerSecondContact: boolean | null;
    readonly customerSecondContactEmail: string | null;
    readonly customerSecondContactName: string | null;
    readonly customerSecondContactNameRole: string | null;
    readonly customerSecondContactPhoneNumber: string | null;
    readonly distributor: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly distributorId: string | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly isVip: boolean | null;
    readonly locations: ReadonlyArray<{
      readonly address: string;
      readonly city: string | null;
      readonly contactName: string | null;
      readonly contactPhone: string | null;
      readonly createdAt: any | null;
      readonly deploymentManager: {
        readonly firstName: string;
        readonly id: string;
      } | null;
      readonly id: string;
      readonly isActive: boolean;
      readonly latitude: string | null;
      readonly launchDate: string | null;
      readonly locationType: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly logJobs: ReadonlyArray<{
        readonly additionalComments: string | null;
        readonly cleanliness: Cleanliness | null;
        readonly closingDateAndTime: string | null;
        readonly createdAt: any;
        readonly createdBy: {
          readonly firstName: string;
          readonly id: string;
        } | null;
        readonly customerSatisfaction: CustomerSatisfaction | null;
        readonly dateAndTime: string;
        readonly id: string;
        readonly jobType: JobTypes;
        readonly locationId: string;
        readonly machineName: string | null;
        readonly machineSerialNumber: string | null;
        readonly status: Status;
        readonly trafficRate: TrafficRate | null;
        readonly uuid: string | null;
      }> | null;
      readonly longitude: string | null;
      readonly machineCount: number | null;
      readonly machines: ReadonlyArray<{
        readonly connectionStatus: ConnectionStatus | null;
        readonly createdAt: any | null;
        readonly createdBy: {
          readonly firstName: string;
          readonly id: string;
        } | null;
        readonly deployingPerson: {
          readonly firstName: string;
          readonly id: string;
        } | null;
        readonly deploymentDate: string;
        readonly hardwareVersion: string | null;
        readonly id: string;
        readonly isRetired: boolean;
        readonly machineStatus: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly name: string | null;
        readonly remark: string | null;
        readonly retiredAt: any | null;
        readonly retiredBy: {
          readonly firstName: string;
          readonly id: string;
        } | null;
        readonly serialNumber: string;
        readonly softwareVersion: string | null;
        readonly tickets: ReadonlyArray<{
          readonly assignTo: {
            readonly firstName: string;
            readonly id: string;
          } | null;
          readonly closingDateAndTime: string | null;
          readonly comment: string | null;
          readonly createdBy: {
            readonly firstName: string;
            readonly id: string;
          } | null;
          readonly id: string;
          readonly machine: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly priority: Priority;
          readonly reportedAt: string | null;
          readonly serviceType: ServiceType | null;
          readonly status: Statuses;
          readonly ticketSource: {
            readonly id: string;
            readonly name: string;
          } | null;
          readonly ticketType: TicketType | null;
          readonly uuid: string | null;
        }> | null;
        readonly uuid: string | null;
      }> | null;
      readonly marketSegment: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly name: string;
      readonly noOfBlenders: number | null;
      readonly noOfFreezers: number | null;
      readonly region: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly regionId: string | null;
      readonly samplingRecommendedDays: number | null;
      readonly samplingRecommendedTime: string | null;
      readonly state: string | null;
      readonly targetLaunchDate: string | null;
      readonly uuid: string | null;
    }> | null;
    readonly name: string;
    readonly typeOfContactPhoneNumber: TypeOfContactPhoneNumber;
    readonly typeOfSecondContactPhoneNumber: TypeOfContactPhoneNumber | null;
    readonly uuid: string | null;
  };
};
export type CustomerHistory_getCustomerByIdQuery = {
  response: CustomerHistory_getCustomerByIdQuery$data;
  variables: CustomerHistory_getCustomerByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v6 = [
  (v1/*: any*/),
  (v3/*: any*/)
],
v7 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "UserObjectType",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingDateAndTime",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CustomerObjectType",
    "kind": "LinkedField",
    "name": "getCustomerById",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "distributorId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerCompanyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerContactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerContactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerContactNameRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerSecondContact",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerSecondContactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerSecondContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerSecondContactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerSecondContactNameRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfSecondContactPhoneNumber",
        "storageKey": null
      },
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVip",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DistributorObjectType",
        "kind": "LinkedField",
        "name": "distributor",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationObjectType",
        "kind": "LinkedField",
        "name": "locations",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "regionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPhone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetLaunchDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "launchDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noOfBlenders",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noOfFreezers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LogJobsObjectType",
            "kind": "LinkedField",
            "name": "logJobs",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateAndTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "machineSerialNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "machineName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "additionalComments",
                "storageKey": null
              },
              (v8/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerSatisfaction",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cleanliness",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trafficRate",
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MachineObjectType",
            "kind": "LinkedField",
            "name": "machines",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serialNumber",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deploymentDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "connectionStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "softwareVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hardwareVersion",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remark",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "retiredAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRetired",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserObjectType",
                "kind": "LinkedField",
                "name": "retiredBy",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserObjectType",
                "kind": "LinkedField",
                "name": "deployingPerson",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MachineStatusObjectType",
                "kind": "LinkedField",
                "name": "machineStatus",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TicketObjectType",
                "kind": "LinkedField",
                "name": "tickets",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MachineObjectType",
                    "kind": "LinkedField",
                    "name": "machine",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ticketType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "comment",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priority",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketSourceObjectType",
                    "kind": "LinkedField",
                    "name": "ticketSource",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reportedAt",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserObjectType",
                    "kind": "LinkedField",
                    "name": "assignTo",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RegionObjectType",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MarketSegmentObjectType",
            "kind": "LinkedField",
            "name": "marketSegment",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationTypeObjectType",
            "kind": "LinkedField",
            "name": "locationType",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserObjectType",
            "kind": "LinkedField",
            "name": "deploymentManager",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "samplingRecommendedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "samplingRecommendedDays",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machineCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerHistory_getCustomerByIdQuery",
    "selections": (v11/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerHistory_getCustomerByIdQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "9505ab94ad27d1ad6dc601f8b5288a93",
    "id": null,
    "metadata": {},
    "name": "CustomerHistory_getCustomerByIdQuery",
    "operationKind": "query",
    "text": "query CustomerHistory_getCustomerByIdQuery(\n  $id: String!\n) {\n  getCustomerById(id: $id) {\n    id\n    uuid\n    name\n    distributorId\n    customerCompanyName\n    customerContactName\n    customerContactPhoneNumber\n    customerContactEmail\n    customerContactNameRole\n    accountType\n    customerSecondContact\n    customerSecondContactName\n    customerSecondContactPhoneNumber\n    customerSecondContactEmail\n    customerSecondContactNameRole\n    typeOfContactPhoneNumber\n    typeOfSecondContactPhoneNumber\n    createdAt\n    isActive\n    isVip\n    distributor {\n      id\n      name\n    }\n    createdBy {\n      id\n      firstName\n    }\n    locations {\n      id\n      uuid\n      name\n      address\n      regionId\n      contactName\n      contactPhone\n      targetLaunchDate\n      launchDate\n      noOfBlenders\n      noOfFreezers\n      logJobs {\n        id\n        uuid\n        jobType\n        locationId\n        dateAndTime\n        machineSerialNumber\n        machineName\n        additionalComments\n        createdBy {\n          id\n          firstName\n        }\n        createdAt\n        customerSatisfaction\n        cleanliness\n        trafficRate\n        status\n        closingDateAndTime\n      }\n      machines {\n        id\n        uuid\n        serialNumber\n        name\n        deploymentDate\n        connectionStatus\n        softwareVersion\n        hardwareVersion\n        createdAt\n        remark\n        retiredAt\n        isRetired\n        retiredBy {\n          id\n          firstName\n        }\n        createdBy {\n          id\n          firstName\n        }\n        deployingPerson {\n          id\n          firstName\n        }\n        machineStatus {\n          id\n          name\n        }\n        tickets {\n          id\n          uuid\n          machine {\n            id\n            name\n          }\n          ticketType\n          serviceType\n          comment\n          priority\n          ticketSource {\n            id\n            name\n          }\n          createdBy {\n            id\n            firstName\n          }\n          reportedAt\n          closingDateAndTime\n          assignTo {\n            id\n            firstName\n          }\n          status\n        }\n      }\n      region {\n        id\n        name\n      }\n      marketSegment {\n        id\n        name\n      }\n      locationType {\n        id\n        name\n      }\n      deploymentManager {\n        id\n        firstName\n      }\n      samplingRecommendedTime\n      samplingRecommendedDays\n      createdAt\n      isActive\n      city\n      state\n      latitude\n      longitude\n      machineCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5485bed3682e5b5c2204bde97f4fa2b9";

export default node;
